<template>
    <div></div>
</template>

<script>
    export default {
        
        computed: {

            updated() {
                return this.$pwa.refreshd
            }
        },

        watch: {

            updated() {
                this.$notify({type: 'primary', message: this.$t('pwa.refreshd') })
            }
        }
    }
</script>